module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAALElEQVRIx2O8IcfKQBvAOGr0sDD6aU40rYz+////qNGjRg9M4hvN6KNG4wUAcq4hH8Fy584AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/at.png
// module id = 770
// module chunks = 0